import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
// import { Document, Page, pdfjs } from 'react-pdf'
import { fixedAssets } from 'src/containers/PreCache'
import { SIZES } from 'src/styles/theme'
import Amplitude from 'src/utils/amplitudeHelper'
// import { useWindowSize } from 'src/utils/useWindowSize'
import styled from 'styled-components'
import { IoClose } from 'react-icons/io5'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import { HiOutlineArrowLeft } from 'react-icons/hi2'
import ProgrammeAccordion from '../ProgrammeAccordion'

// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const SharedModal = styled(Modal)`
  left: ${(props) => (props.open ? '0' : '100%')};
  transition: 1s !important;
  /* &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  
  scrollbar-width: none;  */
  scrollbar-width: thin;
  .modal-dialog {
    width: 100%;
    max-width: 90%;
    margin: 0 !important;
    margin-left: auto !important;
    border-radius: 0;
  }

  h2 {
    font-weight: 700;
    font-size: 32px;
    line-height: 36px;
    color: #ffffff;

    @media (max-width: 768px) {
      font-size: 24px;
      line-height: 28px;
    }
  }

  .close-modal-btn {
    position: sticky;
    top: 500px;
    max-width: 45px !important;
    margin-left: -1.5%;
    z-index: 99999;
    width: 38px;
    height: 38px;
  }

  .modal-content {
    border-radius: 0;
    width: 100%;
    min-height: 100vh;
    max-width: 100%;
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(17.25px);
  }

  .modal-header {
    border: none;
  }

  p.file-description {
    padding: 8px auto;
    font-size: 16px;
    margin: 0;
    color: #fff;
    font-weight: 500;
    text-align: center;
    text-transform: uppercase;
  }
  .modal-body {
    padding: 0;
    width: 100%;
    max-width: 90%;
    margin: 0 auto;
  }

  ${SIZES.mobile} {
    .programme-img {
      width: 100%;
      max-width: 100%;
      height: auto;
    }
    .modal-dialog {
      max-width: 100%;
    }
    .modal-header {
      display: flex;
      align-items: center;
      button.close {
        position: static;
        margin: 0;
        padding: 0;
      }
    }
    .modal-content {
      background: rgba(0, 0, 0, 0.6);
      backdrop-filter: blur(17.25px);
    }
  }
`

export const VirtualAgendaModal = ({ showModal, hideModal }) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    Amplitude.clickAgenda()
    setOpen(true)
  }, [])

  const toggleModal = () => {
    setOpen(false)
    setTimeout(hideModal, 900)
  }

  return (
    <SharedModal open={open} show={showModal} onHide={toggleModal} size="lg" aria-labelledby="gallery-pdf-modal" centered animation={false}>
      <Modal.Header className="d-flex align-items-center justify-content-center position-relative">
        <div onClick={toggleModal}>
          <IoClose size={32} className=" text-white" />
        </div>
        <h2 className="w-100 fw-bold text-center">Programme & Speakers</h2>
      </Modal.Header>
      <button className="close-modal-btn d-none d-md-flex align-items-center justify-content-center " onClick={toggleModal}>
        <HiOutlineArrowLeft size={38} />
      </button>
      <Modal.Body>
        <ProgrammeAccordion />
      </Modal.Body>
    </SharedModal>
  )
}
